import React, { FC } from "react";
import { Box, Button } from "@chakra-ui/react";
import {
  GRS_PENDING_ROW_BG,
  GRS_VISIBLE_FOCUS_RING,
} from "constants/grs-pending-leads";

interface IGrsPendingLeadsShowMoreRowProps {
  total: number;
  nextRevealCount: number;
  onShowMore: () => void;
}

export const GrsPendingLeadsShowMoreRow: FC<IGrsPendingLeadsShowMoreRowProps> = ({
  total,
  nextRevealCount,
  onShowMore,
}) => {
  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      width={"max-content"}
      minWidth={"100%"}
      px={4}
      py={2}
      borderBottom={"1px solid"}
      borderColor={"gray.100"}
      bg={GRS_PENDING_ROW_BG}
      color={"leadpro.700"}
      role={"row"}
    >
      <Box role={"cell"}>
        <Button
          variant={"link"}
          colorScheme={"blue"}
          onClick={onShowMore}
          _focusVisible={GRS_VISIBLE_FOCUS_RING}
        >
          {total} total, click to show {nextRevealCount} more
        </Button>
      </Box>
    </Box>
  );
};
